import { getCatalogStatusCanonical, getCatalogStatusLabel, normalizeCatalogStatus } from './articleCatalogStatusOptions';

/** Normalize actif/active and extended lifecycle statuses across Articles module pages. */
export function isArticleActiveStatus(status) {
  return getCatalogStatusCanonical(status) === 'active';
}

export function isArticleInactiveStatus(status) {
  return getCatalogStatusCanonical(status) === 'inactive';
}

export function matchesArticleStatusFilter(recordStatus, filterId) {
  if (filterId === 'all') return true;
  const canonical = getCatalogStatusCanonical(recordStatus);
  if (filterId === 'actif' || filterId === 'active') return canonical === 'active';
  if (filterId === 'inactif' || filterId === 'inactive') return canonical === 'inactive';
  if (filterId === 'brouillon' || filterId === 'draft') return canonical === 'draft';
  if (filterId === 'suspendu' || filterId === 'suspended') return canonical === 'suspended';
  if (filterId === 'archive' || filterId === 'archived') return canonical === 'archived';
  return normalizeCatalogStatus(recordStatus) === normalizeCatalogStatus(filterId);
}

export function countArticleActive(records) {
  return records.filter((r) => isArticleActiveStatus(r.status)).length;
}

export function countArticleInactive(records) {
  return records.filter((r) => isArticleInactiveStatus(r.status)).length;
}

export function getArticleStatusLabel(status, t) {
  return getCatalogStatusLabel(status, t);
}
